import { useTranslation } from "react-i18next";

import { MainLayout } from "components/layouts";
import ShiftsForm from "./ShiftsForm";
import { Breadcrumb, Flex, Space } from "antd";


const ShiftView = (props) => {
  const { t } = useTranslation();

  return (
    <MainLayout>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("configuration.header"), href: "/configuration/attendance" },
            {
              title: t("attendance_setting.header"),
              href: "/configuration/attendance",
            },
            { title: t("shift.header") },
          ]} />
          <h2>{t("shift.header")}</h2>
        </Flex>
        <ShiftsForm {...props} />
      </Space>
    </MainLayout>
  );
};

export default ShiftView;
